import React, { useEffect } from 'react';
import { Card, Divider, Button, Space, Alert } from 'antd';
import { ClockCircleOutlined, CopyOutlined } from '@ant-design/icons';
import DayScheduleRow from './DayScheduleRow';
import { DAYS_OF_WEEK, DEFAULT_WORKING_HOURS } from '../../utils/constants';

const WorkingHoursManager = ({ value, onChange, disabled = false }) => {
  const workingHours = value || DEFAULT_WORKING_HOURS;

  useEffect(() => {
    if (!value) {
      onChange(DEFAULT_WORKING_HOURS);
    }
  }, [value, onChange]);

  const handleDayChange = (day, dayValue) => {
    onChange({
      ...workingHours,
      [day]: dayValue,
    });
  };

  const copyMondayToAll = () => {
    const mondaySchedule = workingHours.monday;
    const newSchedule = {};

    DAYS_OF_WEEK.forEach((day) => {
      newSchedule[day.value] = { ...mondaySchedule };
    });

    onChange(newSchedule);
  };

  const setAllClosed = () => {
    const closedSchedule = {};

    DAYS_OF_WEEK.forEach((day) => {
      closedSchedule[day.value] = {
        is_open: false,
        open_time: null,
        close_time: null,
      };
    });

    onChange(closedSchedule);
  };

  const setBusinessHours = () => {
    const businessSchedule = {};

    DAYS_OF_WEEK.forEach((day) => {
      const isWeekday = !['saturday', 'sunday'].includes(day.value);
      businessSchedule[day.value] = {
        is_open: isWeekday,
        open_time: isWeekday ? '09:00' : null,
        close_time: isWeekday ? '18:00' : null,
      };
    });

    onChange(businessSchedule);
  };

  return (
    <Card
      title={
        <Space>
          <ClockCircleOutlined />
          Working Hours Schedule
        </Space>
      }
      extra={
        <Space wrap>
          <Button
            size="small"
            icon={<CopyOutlined />}
            onClick={copyMondayToAll}
            disabled={disabled}
          >
            Copy Monday to All
          </Button>
          <Button size="small" onClick={setBusinessHours} disabled={disabled}>
            Business Hours
          </Button>
          <Button size="small" danger onClick={setAllClosed} disabled={disabled}>
            Close All
          </Button>
        </Space>
      }
    >
      <Alert
        message="Set the clinic's operating hours for each day of the week"
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />

      {DAYS_OF_WEEK.map((day, index) => (
        <React.Fragment key={day.value}>
          <DayScheduleRow
            day={day.value}
            label={day.label}
            value={workingHours[day.value]}
            onChange={(dayValue) => handleDayChange(day.value, dayValue)}
            disabled={disabled}
          />
          {index < DAYS_OF_WEEK.length - 1 && <Divider style={{ margin: '8px 0' }} />}
        </React.Fragment>
      ))}
    </Card>
  );
};

export default WorkingHoursManager;